import Tooltip from '../Tooltip/Tooltip';
import './BotaoPadrao.css';

const BotaoPadrao = ({
    aoClicar,
    texto,
    confirmar,
    cancelar,
    desabilitado,
    classeCustom,
    icone,
    textoTooltip = '',
    apenasIcone = false
}) => {

    let classeIcone = '';
    if (apenasIcone) {
        if (texto && texto.trim() !== '') {
            classeIcone = 'botao-padrao-icone-texto';
        } else {
            classeIcone = 'botao-padrao-apenas-icone';
        }
    }

    return (  
        <Tooltip
            text={textoTooltip}
        >
            <button
                className={
                    `${confirmar ? 'botao-padrao-confirmar' : ''}
                    ${cancelar ? 'botao-padrao-cancelar' : ''}
                    botao-padrao
                    ${desabilitado ? 'botao-padrao-desabilitado' : ''}
                    ${classeCustom}
                    ${classeIcone}`
                }
                disabled={desabilitado}
                onClick={aoClicar}
            >
                {icone && <span className="icone-botao">{icone}</span>}
                {(texto || '')}
            </button>
        </Tooltip>
    );
}
 
export default BotaoPadrao;